// 外部リンクblank化
// window.addEventListener('DOMContentLoaded', function() {
//   const links = document.links;
//   const linksLength = links.length;
//   for (let i = 0; i < linksLength ; i++) {
//     if (links[i].hostname !== window.location.hostname) {
//       links[i].target = '_blank';
//       links[i].rel = 'noreferrer noopener';
//     }
//   }
// });

document.querySelectorAll('a.button').forEach(function(link) {
  // リンクが相対パスかどうかをチェック
  if (link.hostname && link.hostname !== window.location.hostname) {
    // target="_blank" を設定
    link.setAttribute('target', '_blank');
    // rel="noopener noreferrer" も追加してセキュリティを強化
    link.setAttribute('rel', 'noopener noreferrer');
  }
});

// フッター外部リンクblank化
window.addEventListener('DOMContentLoaded', function() {
  const footerLinks = document.querySelectorAll('.footer_link_list_item a');
  const footerLinksLength = footerLinks.length;
  
  for (let i = 0; i < footerLinksLength ; i++) {
    if (footerLinks[i].hostname !== window.location.hostname) {
      footerLinks[i].target = '_blank';
      footerLinks[i].rel = 'noreferrer noopener';
    }
  }
});

//スティッキー要素(途中からに対応)
$(function(){
    if($('.faq_selector_wrapper').length){
        $(function () {
            var glovalNav = $('.faq_selector_wrapper'); // グローバルナビゲーションのセレクタ 
            var navHeight = glovalNav.outerHeight(true); // ナビゲーションのheight(marginやpadding,box-shadowも含む)

            // ロード時にoffsetAdjustmentを計算
            var offsetAdjustment = $(window).width() >= 787 ? 100 : 80;
            var navOffset = glovalNav.offset().top - offsetAdjustment; // ブラウザの一番上からナビゲーションまでの位置

            // スクロールした時 
            $(window).scroll(function () {
                var topValue = $(window).width() >= 787 ? '100px' : '80px';

                // スクロールがナビゲーション位置に来たら 
                if ($(this).scrollTop() > navOffset) {
                    // ナビゲーションをfixedさせる
                    glovalNav.css({
                        'position': 'fixed',
                        'top': topValue,
                    });
                    $('#faq_sticky_box').css('padding-bottom', navHeight);
                    glovalNav.addClass('fixed_item');
                } else {
                    // ナビゲーション位置に来ていない時は static で元に戻す。
                    glovalNav.css({
                        'position': 'relative',
                        'top': '0',
                    });
                    $('#faq_sticky_box').css('padding-bottom', '0');
                    glovalNav.removeClass('fixed_item');
                }
            });
        });
    } else {
    }
});

